import { FC, useCallback } from 'react';

import { TabType } from './TabType';
import { TabRoot } from './Tab.Root';
import { TabText } from './Tab.Text';

/**
 * Пропсы компонента вкладки табов
 */
type TabProps = {
  tab: TabType;
  isActive: boolean;
  activate: (tabId: string) => void;
};

/**
 * Компонент вкладки табов
 */
export const Tab: FC<TabProps> = ({ tab, isActive, activate }) => {
  const onClick = useCallback(() => activate(tab.id), [tab, activate]);
  return (
    <TabRoot onClick={onClick}>
      <TabText isActive={isActive}>{tab.text}</TabText>
    </TabRoot>
  );
};
